import { render } from "./meteorology.vue?vue&type=template&id=5bd534b0"
import script from "./meteorology.vue?vue&type=script&lang=js"
export * from "./meteorology.vue?vue&type=script&lang=js"

import "./meteorology.vue?vue&type=style&index=0&id=5bd534b0&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__